module.exports = __webpack_public_path__ + "static/media/ADDVA_SMALL.7b1d49d7.svg";